var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 24,
  viewBox: "0 0 36 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3880",
  "data-name": "Group 3880",
  transform: "translate(-539 -107)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2544",
  "data-name": "Rectangle 2544",
  width: 36,
  height: 24,
  rx: 2,
  transform: "translate(539 107)",
  fill: "#fff",
  opacity: 0
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3878",
  "data-name": "Group 3878",
  transform: "translate(61)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3872",
  "data-name": "Group 3872",
  transform: "translate(484 113.001)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_113",
  "data-name": "Path 113",
  d: "M-193-766.254h4.7",
  transform: "translate(193 771.873)",
  fill: "none",
  stroke: "#f0321a",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "Subtraction_1",
  "data-name": "Subtraction 1",
  transform: "translate(4.53)",
  fill: "#f0321a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 5.598378658294678 11.46545219421387 C 4.281169891357422 11.32051372528076 3.065627336502075 10.75136947631836 2.130898952484131 9.833755493164062 C 1.079198837280273 8.80125617980957 0.4999988377094269 7.439975738525391 0.4999988377094269 6.000665664672852 C 0.4999988377094269 4.560755729675293 1.079208850860596 3.199055671691895 2.130938768386841 2.166385650634766 C 3.066044330596924 1.248246908187866 4.282218456268311 0.6789742708206177 5.598378658294678 0.5343930721282959 L 5.598378658294678 11.46545219421387 Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 5.098378658294678 10.87894344329834 L 5.098378658294678 1.121055364608765 C 4.108504772186279 1.333349347114563 3.202873229980469 1.814626097679138 2.481238842010498 2.523155689239502 C 1.526048898696899 3.461045742034912 0.9999988675117493 4.696045875549316 0.9999988675117493 6.000665664672852 C 0.9999988675117493 7.304675579071045 1.526028871536255 8.53924560546875 2.481178760528564 9.476945877075195 C 3.202854156494141 10.18541431427002 4.108522891998291 10.66666603088379 5.098378658294678 10.87894344329834 M 6.098378658294678 11.99999618530273 L 6.096758842468262 11.99994564056396 C 4.459249019622803 11.95796585083008 2.926418781280518 11.31537532806396 1.780628800392151 10.19055557250977 C 0.6323688626289368 9.063265800476074 -1.14768977255153e-06 7.575275897979736 -1.14768977255153e-06 6.000665664672852 C -1.14768977255153e-06 4.425475597381592 0.6323688626289368 2.937065601348877 1.780628800392151 1.809615731239319 C 2.926758766174316 0.6842857003211975 4.460158824920654 0.04162570834159851 6.098378658294678 -4.291534423828125e-06 L 6.098378658294678 11.99999618530273 Z",
  stroke: "none",
  fill: "#f0321a"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3873",
  "data-name": "Group 3873",
  transform: "translate(496.861 113.001)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_114",
  "data-name": "Path 114",
  d: "M-188.3-766.254H-193",
  transform: "translate(199.438 771.873)",
  fill: "none",
  stroke: "#f0321a",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "Subtraction_2",
  "data-name": "Subtraction 2",
  transform: "translate(6.098 12) rotate(180)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.1,0h0A6.364,6.364,0,0,0,1.781,1.809a5.821,5.821,0,0,0,0,8.381A6.364,6.364,0,0,0,6.1,12V0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 5.098378658294678 1.121047019958496 C 4.108522891998291 1.333324432373047 3.202856540679932 1.814571380615234 2.481188535690308 2.523025512695312 C 1.526028633117676 3.460745811462402 0.9999985694885254 4.695315837860107 0.9999985694885254 5.999325752258301 C 0.9999985694885254 7.303935527801514 1.52604866027832 8.538946151733398 2.481228590011597 9.476825714111328 C 3.20287036895752 10.18536281585693 4.108504295349121 10.66664123535156 5.098378658294678 10.87893581390381 L 5.098378658294678 1.121047019958496 M 6.098378658294678 -4.76837158203125e-06 L 6.098378658294678 11.99999618530273 C 4.460158348083496 11.95836544036865 2.926758527755737 11.31570529937744 1.780628681182861 10.19037532806396 C 0.6323685646057129 9.062915802001953 -1.430511474609375e-06 7.574515819549561 -1.430511474609375e-06 5.999325752258301 C -1.430511474609375e-06 4.424715518951416 0.6323685646057129 2.936725616455078 1.780628681182861 1.809435844421387 C 2.926418542861938 0.6846160888671875 4.459248542785645 0.04202556610107422 6.096758842468262 4.57763671875e-05 L 6.098378658294678 -4.76837158203125e-06 Z",
  stroke: "none",
  fill: "#f0321a"
})))))));
export default __webpack_public_path__ + "static/media/disconnectedstore.66aaa7b1.svg";
export { SvgComponent as ReactComponent };